import React, { useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Box,
    Typography,
    Modal,
    Backdrop,
    Fade,
    IconButton,
    Drawer,
    useTheme,
    useMediaQuery,
    Switch
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";
import { Close, CloseRounded } from "@mui/icons-material";
import { CircleLoader, BounceLoader, ClipLoader } from 'react-spinners'


const CreateCommunityPopup = ({ open, onClose, width = 420, onComplete = () => { } }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [spaceName, setSpaceName] = useState("")
    const [spaceDescription, setSpaceDescription] = useState("")
    const [spaceSupportMail, setSpaceSupportMail] = useState("")
    const [spaceType, setSpaceType] = useState("")
    const [loading, setLoading] = useState(false)
    const [isPaid, setIsPaid] = useState(false)
    const [planId, setPlanId] = useState("")
    const [lat, setLat] = useState("")
    const [lng, setLng] = useState("")
    const [shortName, setShortName] = useState("")
    const [tag, setTag] = useState("")
    const [domains, setDomains] = useState([])
    const [approvalRequired, setApprovalRequired] = useState(false)
    const [logo, setLogo] = useState(null)

    const createSpace = async () => {
        setLoading(true);
        const token = localStorage.getItem("token");

        const formData = new FormData();
        formData.append("title", spaceName);
        formData.append("description", spaceDescription);
        formData.append("communityMail", spaceSupportMail);
        formData.append("communityType", spaceType);
        formData.append("locationCoordinates", JSON.stringify({ latitude: lat, longitude: lng }));
        formData.append("allowedDomains", JSON.stringify(domains));
        formData.append("approvalRequired", `${approvalRequired}`);
        formData.append("name", shortName);
        formData.append("tag", tag);
        formData.append("planId", isPaid && planId ? planId : "");

        // 👇 logo image
        if (logo instanceof File) {
            console.log(logo)
            formData.append("media", logo, logo.name);   // input file object
        }else{
            alert("Not a valid logo selected")
            return 
        }

        try {
            const response = await fetch(`${BASE_URL}/community/create`, {
                method: "POST",
                headers: {
                    "auth-token": token   // DO NOT add Content-Type
                },
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                onComplete();
            } else {
                alert(data.response);
            }
        } catch (err) {
            console.error(err);
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };


    const labelStyle = {
        fontSize: "12px",
        fontFamily: "poppins-reg",
        color: "#ffffff",
        marginInline: "18px",
        marginTop: "14px",
        marginBottom: "4px"
    };

    const inputBox = {
        flexDirection: 'row',
        display: 'flex',
        borderRadius: "10px",
        marginInline: "15px",
        border: "1px solid #aaaaaa30",
        background: "#000000"
    };

    const inputStyle = {
        outline: 'none',
        backgroundColor: "transparent",
        borderWidth: 0,
        padding: "12px 15px",
        flex: 1,
        fontSize: "14px",
        fontFamily: 'poppins-reg',
        color: "white"
    };

    const rowBox = {
        display: "flex",
        alignItems: "center",
        marginInline: "18px",
        gap: "10px",
        marginTop: "6px"
    };




    return (
        <Drawer
            anchor={isMobile ? "bottom" : "right"}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: isMobile ? "100%" : 420,
                    height: isMobile ? "85vh" : "100vh",
                    borderRadius: isMobile ? "20px 20px 0 0" : 0,
                    background: "#0f0e0fff",
                    flexDirection: 'column',
                    display: 'flex'
                }
            }}
        >



            {/* Body */}
            <Box sx={styles.body}>
                <Box sx={styles.header}>
                    <IconButton onClick={onClose}>
                        <CloseRounded />
                    </IconButton>
                    <span style={styles.title}>{"Create new community"}</span>

                </Box>

                <Box sx={{ flexDirection: 'column', flex: 1, display: 'flex', overflow: 'scroll' }} >
                    <Typography style={{
                        fontSize: "12px",
                        fontFamily: "poppins-reg", color: "#ffffff",
                        marginInline: "18px", marginTop: "20px", marginBottom: "4px"
                    }}>{"Title"}</Typography>
                    <Box sx={{
                        flexDirection: 'row',
                        backgroundColor: "#ffffff10",
                        display: 'flex',
                        borderRadius: "10px",
                        marginInline: "15px",
                        border: "1px solid #aaaaaa30",
                        background: "#000000"
                    }}>

                        <input placeholder="Enter community title..."
                            multiple={false}
                            value={spaceName}
                            onChange={(v) => {
                                setSpaceName(v.target.value)
                            }}
                            style={{
                                outline: 'none',
                                backgroundColor: "#aaaaaa00",
                                borderWidth: 0,
                                paddingLeft: "15px",
                                paddingRight: "15px",
                                paddingTop: "12px",
                                flex: 1,
                                display: 'flex',
                                fontSize: "14px",
                                paddingBottom: "12px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }} />


                    </Box>

                    <Typography style={{
                        fontSize: "12px",
                        fontFamily: "poppins-reg", color: "#ffffff",
                        marginInline: "18px", marginTop: "10px", marginBottom: "4px"
                    }}>{"Display Name"}</Typography>
                    <Box sx={{
                        flexDirection: 'row',
                        backgroundColor: "#ffffff10",
                        display: 'flex',
                        borderRadius: "10px",
                        marginInline: "15px",
                        border: "1px solid #aaaaaa30",
                        background: "#000000"
                    }}>

                        <input placeholder="Enter short name to display..."
                            multiple={false}
                            value={shortName}
                            onChange={(v) => {
                                setShortName(v.target.value)
                            }}
                            style={{
                                outline: 'none',
                                backgroundColor: "#aaaaaa00",
                                borderWidth: 0,
                                paddingLeft: "15px",
                                paddingRight: "15px",
                                paddingTop: "12px",
                                flex: 1,
                                display: 'flex',
                                fontSize: "14px",
                                paddingBottom: "12px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }} />


                    </Box>

                    <Typography style={{
                        fontSize: "12px",
                        fontFamily: "poppins-reg", color: "#ffffff",
                        marginInline: "18px", marginTop: "10px", marginBottom: "4px"
                    }}>{"Description"}</Typography>
                    <Box sx={{
                        flexDirection: 'row',
                        backgroundColor: "#ffffff10",
                        display: 'flex',
                        marginInline: "15px",
                        borderRadius: "10px",
                        border: "1px solid #aaaaaa30",
                        background: "#000000"
                    }}>

                        <textarea placeholder="Enter description..."
                            rows={3}
                            value={spaceDescription}

                            onChange={(v) => {
                                setSpaceDescription(v.target.value)
                            }}
                            style={{
                                outline: 'none',
                                backgroundColor: "#aaaaaa00",
                                borderWidth: 0,
                                paddingLeft: "15px",
                                paddingRight: "15px",
                                paddingTop: "12px",
                                flex: 1,
                                display: 'flex',
                                fontSize: "14px",
                                paddingBottom: "12px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }} />


                    </Box>
                    <Typography style={{
                        fontSize: "12px",
                        fontFamily: "poppins-reg", color: "#ffffff",
                        marginInline: "18px", marginTop: "10px", marginBottom: "4px"
                    }}>{"Support Mail"}</Typography>
                    <Box sx={{
                        flexDirection: 'row',
                        backgroundColor: "#ffffff10",
                        display: 'flex',
                        marginInline: "15px",
                        borderRadius: "10px",
                        border: "1px solid #aaaaaa30",
                        background: "#000000"
                    }}>

                        <input
                            multiple={false}
                            inputMode={'email'}
                            type={'email'}
                            placeholder="Enter support mail..."
                            value={spaceSupportMail}

                            onChange={(v) => {
                                setSpaceSupportMail(v.target.value)
                            }}
                            style={{
                                outline: 'none',
                                backgroundColor: "#aaaaaa00",
                                borderWidth: 0,
                                paddingLeft: "15px",
                                paddingRight: "15px",
                                paddingTop: "12px",
                                flex: 1,
                                display: 'flex',
                                fontSize: "14px",
                                paddingBottom: "12px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }} />

                    </Box>

                    <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', marginInline: "18px", marginTop: "10px", gap: "20px" }}>

                        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>

                            <Typography style={{
                                fontSize: "12px",
                                fontFamily: "poppins-reg", color: "#ffffff",

                            }}>{"Community Type"}</Typography>

                            <FormControl margin="dense" required sx={{}}>
                                <Select style={{
                                    fontFamily: 'poppins-reg', fontSize: "14px",
                                }} sx={{
                                    fontFamily: "poppins-reg",
                                    fontSize: 14,

                                    // HEIGHT / PADDING
                                    "& .MuiSelect-select": {
                                        padding: "12px 14px",
                                        background: "#000000",
                                        borderRadius: "10px",
                                    },

                                    // BORDER COLOR
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#aaaaaa30",
                                        borderRadius: "10px",
                                    },

                                    // HOVER
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#aaaaaa30",
                                    },

                                    // FOCUSED
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#aaaaaa30",
                                        borderWidth: "1px",
                                    },

                                    // TEXT COLOR
                                    color: "#ffffff",
                                }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                bgcolor: "#000000",
                                                color: "#ffffff",
                                            }
                                        }
                                    }} name="Space Type" value={spaceType} onChange={(value) => setSpaceType(value.target.value)} required>
                                    {["Campus", "Business"].map((creator) => (
                                        <MenuItem key={creator} value={creator}>{creator}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                            <Typography style={{
                                fontSize: "12px",
                                fontFamily: "poppins-reg", color: "#ffffff",

                            }}>{"Community Tag"}</Typography>
                            <Box sx={{
                                flexDirection: 'row',
                                backgroundColor: "#ffffff10",
                                display: 'flex',
                                borderRadius: "10px",
                                border: "1px solid #aaaaaa30",
                                marginTop: "6px",
                                background: "#000000"
                            }}>

                                <input placeholder="Enter a short tag..."
                                    multiple={false}
                                    value={tag}
                                    onChange={(v) => {
                                        setTag(v.target.value)
                                    }}
                                    style={{
                                        outline: 'none',
                                        backgroundColor: "#aaaaaa00",
                                        borderWidth: "0px",
                                        paddingLeft: "13px",
                                        paddingRight: "13px",
                                        paddingTop: "10px",
                                        flex: 1,
                                        display: 'flex',
                                        fontSize: "14px",
                                        paddingBottom: "10px",
                                        fontFamily: 'poppins-reg',
                                        color: "white"
                                    }} />


                            </Box>
                        </Box>

                    </Box>

                    <Box sx={{ flexDirection: 'row', alignItems: "center", display: 'flex', marginInline: "18px", marginTop: "10px" }}>

                        <Box onClick={() => {
                            setApprovalRequired(!approvalRequired)
                        }} sx={{ display: "flex", flexDirection: 'column', flex: 1, cursor: 'pointer' }}>
                            <Typography sx={{
                                fontSize: "12px",
                                fontFamily: "poppins-reg", color: "#ffffff",
                            }}>Required Approval to Join?</Typography>

                            <Typography sx={{
                                color: "#ffffff90", fontSize: "10px",
                                fontFamily: "poppins-reg",
                            }}>
                                {approvalRequired ? "Users will join on admin approval" : "Approval not required"}
                            </Typography>
                        </Box>
                        <Switch style={{
                            color: approvalRequired ? "#943bff" : "#aaaaaa",

                        }} checked={approvalRequired} onChange={(e) => setApprovalRequired(e.target.checked)} />

                    </Box>

                    <Box sx={{ flexDirection: 'row', alignItems: "center", display: 'flex', marginInline: "18px", marginTop: "10px" }}>

                        <Box onClick={() => {
                            setIsPaid(!isPaid)
                        }} sx={{ display: "flex", flexDirection: 'column', flex: 1, cursor: 'pointer' }}>
                            <Typography sx={{
                                fontSize: "12px",
                                fontFamily: "poppins-reg", color: "#ffffff",
                            }}>Paid Community?</Typography>

                            <Typography sx={{
                                color: "#ffffff90", fontSize: "10px",
                                fontFamily: "poppins-reg",
                            }}>
                                {isPaid ? "Yes, this is a paid community" : "No, this is free"}
                            </Typography>
                        </Box>
                        <Switch style={{
                            color: isPaid ? "#943bff" : "#aaaaaa",

                        }} checked={isPaid} onChange={(e) => setIsPaid(e.target.checked)} />

                    </Box>



                    {isPaid && (
                        <>
                            <Typography sx={labelStyle}>Plan ID</Typography>
                            <Box sx={inputBox}>
                                <input
                                    placeholder="Enter plan id..."
                                    value={planId}
                                    onChange={(e) => setPlanId(e.target.value)}
                                    style={inputStyle}
                                />
                            </Box>
                        </>
                    )}

                    <Typography sx={labelStyle}>Location Coordinates</Typography>

                    <Box sx={{
                        display: 'flex', gap: "20px", flexDirection: 'row', alignItems: 'center',
                        marginInline: "15px",
                    }}>
                        <Box sx={{
                            flexDirection: 'row',
                            backgroundColor: "#ffffff10",
                            display: 'flex',
                            borderRadius: "10px",
                            border: "1px solid #aaaaaa30",
                            marginTop: "6px",
                            width: "40%",
                            background: "#000000"
                        }}>
                            <input placeholder="Latitude" value={lat} onChange={(e) => setLat(e.target.value)} style={{
                                outline: 'none',
                                backgroundColor: "#aaaaaa00",
                                borderWidth: "0px",
                                paddingLeft: "13px",
                                paddingRight: "13px",
                                paddingTop: "10px",
                                flex: 1,
                                display: 'flex',
                                fontSize: "14px",
                                paddingBottom: "10px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }} />
                        </Box>
                        <Box sx={{
                            flexDirection: 'row',
                            backgroundColor: "#ffffff10",
                            display: 'flex',
                            borderRadius: "10px",
                            border: "1px solid #aaaaaa30",
                            width: "40%",
                            marginTop: "6px",
                            background: "#000000"
                        }}>
                            <input placeholder="Longitude" value={lng} onChange={(e) => setLng(e.target.value)} style={{
                                outline: 'none',
                                backgroundColor: "#aaaaaa00",
                                borderWidth: "0px",
                                paddingLeft: "13px",
                                paddingRight: "13px",
                                paddingTop: "10px",
                                flex: 1,
                                display: 'flex',
                                fontSize: "14px",
                                paddingBottom: "10px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }} />
                        </Box>
                    </Box>

                    <Typography sx={labelStyle}>Allowed Domains</Typography>

                    <Box sx={inputBox}>
                        <input
                            placeholder="Add allows email domain and press Enter..."
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    setDomains([...domains, e.target.value]);
                                    e.target.value = "";
                                }
                            }}
                            style={inputStyle}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: "10px", marginInline: "15px", marginTop: "10px" }}>
                        {domains.map((d, i) => (
                            <Box onClick={() => {
                                const newList = domains.filter(dm => dm != d)
                                setDomains(newList)
                            }} key={i} sx={{
                                padding: "6px 12px",
                                borderRadius: 20,
                                background: "#ffffff10",
                                fontSize: "12px",
                                cursor: 'pointer',
                                fontFamily: "poppins-reg",
                                color: "#fff", flexDirection: 'row', display: 'flex',
                                alignItems: 'center'
                            }}>{d}<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: "5px" }}><Close style={{ width: "15px", height: "15px" }} /></Box></Box>
                        ))}
                    </Box>

                    <Typography sx={labelStyle}>Community Logo</Typography>

                    <Box sx={inputBox}>
                        <input type="file" accept="image/*" onChange={(e) => setLogo(e.target.files[0])} style={{
                            ...inputStyle,
                            paddingTop: 10
                        }} />
                    </Box>

                    <Box sx={{ display: 'flex', minHeight: "100px" }} />

                </Box>









                <Box onClick={() => {
                    if (spaceName.length == 0 || spaceDescription.length == 0 || spaceSupportMail.length == 0 || spaceType.length == 0) {
                        alert("Make sure to enter all the required fields.")
                    } else {
                        createSpace()
                    }
                }} sx={{
                    background: "#943bff", borderRadius: "100px", marginInline: "15px", marginBottom: "20px",
                    display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBlock: "13px",
                    userSelect: 'none', cursor: 'pointer'
                }}>
                    {
                        loading ? (
                            <Box sx={{ display: 'flex', alignSelf: 'center', marginBlock: "2px" }}>
                                <ClipLoader size={"18px"} color={"#ffffff"} />
                            </Box>
                        ) : (
                            <Typography sx={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff" }} >Create</Typography>
                        )
                    }

                </Box>

            </Box>
        </Drawer>

    );
};

const styles = {
    popup: (width) => ({
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width,
        maxWidth: "90%",
        maxHeight: "85vh",
        bgcolor: "#0f0f0f",
        borderRadius: 3,
        boxShadow: 24,
        overflow: "hidden"
    }),
    header: {
        display: "flex",
        alignItems: "center",
        px: 1,
        py: 2,
        borderBottom: "1px solid #aaaaaa20"
    },
    title: {
        fontSize: "14px",
        fontFamily: "poppins-reg"
    },
    body: {
        overflowY: "auto",
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    }
};


export default CreateCommunityPopup;
